import { cn } from '@/lib/format'

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost'
export type ButtonSize = 'sm' | 'md'

const VARIANTS: Record<ButtonVariant, string> = {
  // Solid ScoreLM orange (#D9531E). One per view: the main action.
  primary: 'bg-accent-solid text-white hover:bg-accent-solid-hover active:bg-accent-solid',
  secondary: 'bg-raised text-ink border border-line hover:bg-hover hover:border-line-strong',
  // Destructive. Only inside Danger zone and confirm dialogs.
  danger: 'bg-bad-solid text-white hover:brightness-110',
  ghost: 'text-muted hover:text-ink hover:bg-hover',
}

const SIZES: Record<ButtonSize, string> = {
  sm: 'h-8 px-2.5 text-xs gap-1.5',
  md: 'h-9 px-3.5 text-[13px] gap-2',
}

export function buttonClasses({
  variant = 'secondary',
  size = 'md',
  block = false,
  className,
}: { variant?: ButtonVariant; size?: ButtonSize; block?: boolean; className?: string } = {}) {
  return cn(
    'inline-flex items-center justify-center rounded-md font-semibold whitespace-nowrap select-none',
    'transition-colors duration-100 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none',
    VARIANTS[variant],
    SIZES[size],
    block && 'w-full',
    className,
  )
}

